<div style="flex: 1; min-height: 0">
  <router-outlet></router-outlet>
</div>
<pl-hijack></pl-hijack>
